import {
  GET_PROVIDER_SERVICE_LIST,
  GET_PROVIDER_SERVICE_LIST_FAILURE,
  GET_PROVIDER_SERVICE_LIST_SUCCESS,
} from './action';

const initialState = {
  loading: false,
  data: [],
  error: '',
};

const getProviderServiceReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_PROVIDER_SERVICE_LIST:
      return { ...state, loading: true };
    case GET_PROVIDER_SERVICE_LIST_SUCCESS:
      return { ...state, loading: false, data: action.payload, error: '' };
    case GET_PROVIDER_SERVICE_LIST_FAILURE:
      return { ...state, loading: false, data: [], error: action.payload };
    default:
      return state;
  }
};

export default getProviderServiceReducer;
